import { Component, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ProfileValidationIconComponent } from "../../components/profile-validation-icon/profile-validation-icon.component";
import { IconFieldModule } from 'primeng/iconfield';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { IReservationData, PIMService, PimNotificationComponent, ReservationService, SettingsService } from 'core-lib';
import { SelectModule } from 'primeng/select';
import { MessageModule } from 'primeng/message';
import { ImageGallery1Component } from '../../components/image-gallery1/image-gallery1.component';
import { CurrencyPipe } from '@angular/common';
import { ConfirmationRoominfoComponent } from "../../components/confirmation-roominfo/confirmation-roominfo.component";
import { ConfirmationCommondetailsComponent } from "../../components/confirmation-commondetails/confirmation-commondetails.component";
import { Router } from '@angular/router';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ConfirmationService as PrimeConfirmationService } from 'primeng/api';
import { reservationStatus } from 'core-lib';
import { ConfirmationTabledetailsComponent } from "../../components/confirmation-tabledetails/confirmation-tabledetails.component";
import { isTableReservation } from './find-reservation.utils';



@Component({
    selector: 'app-find-reservation',
    imports: [
        TranslateModule,
        ProfileValidationIconComponent,
        IconFieldModule,
        ButtonModule,
        InputTextModule,
        ReactiveFormsModule,
        SelectModule,
        MessageModule,
        ConfirmationRoominfoComponent,
        ConfirmationCommondetailsComponent,
        ConfirmationTabledetailsComponent,
        ConfirmPopupModule,
        PimNotificationComponent
    ],
    templateUrl: './find-reservation.component.html',
    styleUrl: './find-reservation.component.scss',
    providers: [PrimeConfirmationService]
})
export class FindReservationComponent implements OnInit {
  language:string;
  findResForm: FormGroup = new FormGroup({
    confirmationNumber: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    hotel: new FormControl('')
  });
  hotelList:{hotelCode:string, hotelName:string}[];
  showSearchError:boolean = false;
  showReservationAlreadyCancelledError:boolean = false;
  showCancelReservationError:boolean = false;
  cancellationConfirmed:boolean = false;


  foundReservation:null|IReservationData;
  foundReservationHotelCode:string;
  foundReservationIsTable:boolean = false;

  constructor(
    private reservationService: ReservationService, 
    private settings: SettingsService, 
    private pimService: PIMService, 
    private translateService: TranslateService,
    private router: Router,
    private primeConfirm: PrimeConfirmationService
  ) {}

  ngOnInit(): void {
    this.language = this.translateService.currentLang;
    let hotels = this.settings.get('app.endpoints');
    this.hotelList = hotels.map((hotel:any) => {
      return {
        hotelCode: hotel.hotelCode,
        hotelName: this.pimService.getHotelInfo(hotel.hotelCode)?.name
      }
    });

    if (hotels.length > 1) {
      this.findResForm.get('hotel')?.addValidators([Validators.required]);
    }

   
  }



  findReservation() {
    this.showSearchError = false;
    this.showReservationAlreadyCancelledError = false;
    if (this.findResForm.valid) {
      let cn = this.findResForm.get('confirmationNumber')?.value;
      let email = this.findResForm.get('email')?.value;

      let hotelCode:string = this.hotelList[0].hotelCode;
      if (this.hotelList.length > 1) {
        hotelCode = this.findResForm.get('hotel')?.value;
      }
      this.reservationService.findReservation(hotelCode, cn, email).subscribe(
        {
          next: (res) =>{
            if (res) {
              let reservation = res;

              if (reservation.status == reservationStatus.CANCELLED) {
                this.showReservationAlreadyCancelledError = true;
              }
              else {
                this.foundReservation = reservation;
                this.foundReservationHotelCode = reservation.hotelId;
                this.foundReservationIsTable = isTableReservation(reservation);
              }
            }
            else {
              this.showSearchError = true;
            }},
          error: (e) => {
            this.showSearchError = true;
          },
          complete: () => console.info('complete') 
        });
    }
  }


  cancelReservation(event: Event) {
    this.showCancelReservationError = false;
    let message = this.translateService.instant("fr.confirmCancellation");
    this.primeConfirm.confirm({
      target: event.target as EventTarget,
      message: message,
      accept: () => {
          this.confirmCancellation();
      }
    });
  }

  confirmCancellation() {
    let hotelCode = this.foundReservationHotelCode;

    if (hotelCode && this.foundReservation) {
      this.reservationService.cancelReservation(hotelCode, this.foundReservation).subscribe({
        next: (res) =>{
          if (res.success) {
            this.cancellationConfirmed = true;
          }
          else {
            this.showCancelReservationError = true;
          }
        },
        error: (e) => {
          this.showCancelReservationError = true;
        }
      });
    }
  }

  navigateHome() {
    this.router.navigate(['/home/']);
  }

  print() {
    window.print();
  }
}
